import React, { useEffect, useState, useRef, useCallback } from 'react';

import Time from '../Time';

import S from './LockScreen.module.css';

const weekDays = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
];
const yearMonth = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

interface State {
  y: number | null;
  delta: number | null;
}

const maxHeight = 400; // TODO: detect automatically based on DOM elements width
const unlockGap = 150;

const getY = (event) =>
  event.touches && event.touches[0] ? event.touches[0].clientY : event.clientY;

const LockScreen = ({ isLocked, onUnlock }) => {
  const initialState: State = {
    y: null,
    delta: null
  };
  const [state, setState] = useState(initialState);
  const slider: React.Ref<HTMLDivElement> = useRef(null);

  const { y, delta } = state;

  const onMouseMove = useCallback(
    (event) => {
      if (y === null) {
        return;
      }
      const clientY = getY(event) || 0;
      setState((prevState) => {
        const delta = clientY - (prevState.y || 0);
        const safeDelta = delta > 0 ? 0 : delta > maxHeight ? maxHeight : delta;
        return { ...prevState, delta: safeDelta };
      });
    },
    [y]
  );

  const startUnlockMove = useCallback((event) => {
    event.preventDefault();
    setState((prevState) => ({ ...prevState, y: getY(event) }));
  }, []);

  const stopUnlockMove = useCallback(() => {
    setState((prevState) => ({ ...prevState, y: null, delta: null }));
    if (maxHeight + (delta || 0) < unlockGap) {
      onUnlock();
    }
  }, [delta, onUnlock]);

  useEffect(() => {
    const $el = slider.current;
    if (!$el || typeof window === 'undefined') {
      return;
    }
    $el.addEventListener('mousedown', startUnlockMove);
    window.document.addEventListener('mouseup', stopUnlockMove);
    window.document.addEventListener('mousemove', onMouseMove);
    // mobile events
    $el.addEventListener('touchstart', startUnlockMove);
    window.document.addEventListener('touchend', stopUnlockMove);
    window.document.addEventListener('touchmove', onMouseMove);

    return () => {
      $el.removeEventListener('mousedown', startUnlockMove);
      window.document.removeEventListener('mouseup', stopUnlockMove);
      window.document.removeEventListener('mousemove', onMouseMove);
      // mobile events
      $el.removeEventListener('touchstart', startUnlockMove);
      window.document.removeEventListener('touchend', stopUnlockMove);
      window.document.removeEventListener('touchmove', onMouseMove);
    };
  }, [onMouseMove, startUnlockMove, stopUnlockMove]);

  const date = new Date();
  const dd = weekDays[date.getDay()];
  const mm = yearMonth[date.getMonth()];

  const top = delta || 0;

  return (
    <div
      className={S.root}
      data-is-locked={isLocked.toString()}
      style={{
        top: isLocked ? top : '-100%',
        transition: top ? undefined : 'top .2s'
      }}
      ref={slider}
    >
      <div className={S.time}>
        <span>
          <Time />
        </span>
        <div className={S.iconTime}>
          <i></i>
        </div>
      </div>
      <div className={S.date}>
        {dd.toLowerCase()}
        <br />
        {date.getDate()} {mm.toLowerCase()}
      </div>
    </div>
  );
};

export default LockScreen;
